import { IconButton, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { Visibility, VisibilityOff } from '@material-ui/icons';

function JsonTable(props) {
  // javascript version of the typescript in ExternalSyncDataTable.tsx, auto converted
  const [expandedRows, setExpandedRows] = useState({});
  const [isTableVisible, setIsTableVisible] = useState(false);

  const toggleRowAndExpandChildren = (rowKey, row) => {
    setExpandedRows((prev) => {
      const newState = { ...prev };
      newState[rowKey] = !prev[rowKey];
      
      // If we're expanding the current row, also expand all immediate children
      if (newState[rowKey] && typeof row === 'object' && row !== null) {
        Object.keys(row).forEach(key => {
          const childValue = row[key];
          if (typeof childValue === 'object' && childValue !== null) {
            const childRowKey = `${rowKey}-${key}`;
            newState[childRowKey] = true;
          }
        });
      }
      return newState;
    });
  };

  const renderRow = (row, rowKey = 'root', level = 0) => {
    return Object.entries(row).map(([key, value]) => {
      const isNested = typeof value === 'object' && value !== null;
      const currentRowKey = `${rowKey}-${key}`;

      return (
        <React.Fragment key={currentRowKey}>
          <tr
            className={`border-b ${isNested ? 'cursor-pointer' : ''}`}
            onClick={isNested ? () => toggleRowAndExpandChildren(currentRowKey, value) : null}
            style={{fontFamily: 'monospace'}}
          >
            <td
              className="border px-4 py-2"
              style={{ paddingLeft: `${level * 20}px` }}
            >
              {isNested ? (
                <span className="flex items-center cursor-pointer">
                  <span className="mr-2 text-xl" style={{ cursor: 'pointer' }}>
                    {expandedRows[currentRowKey] ? '▼' : '▶'}
                  </span>
                  <strong>{key}</strong>
                </span>
              ) : (
                <strong>{key}</strong>
              )}
            </td>
            <td className="border px-4 py-2">
              {!isNested
                ? value !== null && value !== undefined
                  ? String(value)
                  : ''
                : ''}
            </td>
          </tr>

          {isNested && expandedRows[currentRowKey] && (
            <tr>
              <td colSpan={2} className="p-0">
                <table className="w-full border-l border-gray-300">
                  <tbody>{renderRow(value, currentRowKey, level + 1)}</tbody>
                </table>
              </td>
            </tr>
          )}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="overflow-x-auto" style={{ marginBottom: '20px'}}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {props?.title && (
          <Typography style={{ color: 'black', display: 'inline' }}>
            {props.title}
          </Typography>
        )}
        <IconButton
          onClick={() => setIsTableVisible(!isTableVisible)}
          className="inline-flex items-center"
          style={{ cursor: 'pointer' }}
        >
          {isTableVisible ? (
            <Visibility style={{ color: 'green', fontSize: '24px' }} />
          ) : (
            <VisibilityOff style={{ color: 'red', fontSize: '24px' }} />
          )}
        </IconButton>
      </div>

      {isTableVisible && (
        <table className="min-w-full border border-gray-300">
          <tbody>
            {Array.isArray(props.data)
              ? props.data.map((item, index) => renderRow(item, `${index}`))
              : renderRow(props.data, 'root')}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default JsonTable;
